const charts = [
    {
        id:'AccountingPendingDonut',
        component:'AccountingPendingDonut',
        title: 'widget_pending_expenses',
        img: require('@/assets/images/demo/AccountingDonutPending.png'),
        can:['IU ACCOUNTING VIEW'],
        width:{ xs:'12', sm:'4',lg:'4'}
    },
    {
        id:'AccountingInvoicedDonut',
        component:'AccountingInvoicedDonut',
        title: 'widget_invoiced_expenses',
        img: require('@/assets/images/demo/AccountingDonutInvoiced.png'),
        can:['IU ACCOUNTING VIEW'],
        width:{ xs:'12', sm:'4',lg:'4'}
    },
    {
        id:'AccountingRejectedDonut',
        component:'AccountingRejectedDonut',
        title: 'widget_rejected_expenses',
        img: require('@/assets/images/demo/AccountingDonutRejected.png'),
        can:['IU ACCOUNTING VIEW'],
        width:{ xs:'12', sm:'4',lg:'4'}
    },
    {
        id:'ComplianceStatusDonut',
        component:'ComplianceDonut',
        title: 'widget_compliance_by_status',
        img: require('@/assets/images/demo/ComplianceDonutStatus.png'),
        can:['IU COMPLIANCE VIEW'],
        width:{ xs:'12', sm:'4',lg:'4'}
    },
    {
        id:'ComplianceTable',
        component:'ComplianceTable',
        title: 'widget_compliance_by_status',
        img: require('@/assets/images/demo/ComplianceTable.png'),
        can:['IU COMPLIANCE VIEW'],
        width:{ xs:'12', sm:'8',lg:'8'},
    },
    {
        id:'EhsStatusDonut',
        component:'EhsDonut',
        title: 'widget_ehs_by_status',
        img: require('@/assets/images/demo/EhsDonutStatus.png'),
        can:['IU EHS VIEW'],
        width:{ xs:'12', sm:'4',lg:'4'}
    },
    {
        id:'EhsTable',
        component:'EhsTable',
        title: 'widget_ehs_by_status',
        img: require('@/assets/images/demo/EhsTable.png'),
        can:['IU EHS VIEW'],
        width:{ xs:'12', sm:'8',lg:'8'},
    },
    {
        id:'EntriesStatusCards',
        component:'EntriesCards',
        title: 'widget_entries_by_status',
        img: require('@/assets/images/demo/EntryCardsStatusClient.png'),
        can:['IU ENTRY VIEW'],
        width:{ xs:'12', sm:'4',lg:'4'}
    },
    {
        id:'EntriesAgingDonut',
        component:'EntriesAgingDonut',
        title: 'widget_entries_by_aging',
        img: require('@/assets/images/demo/EntryDonutAging.png'),
        can:['IU ENTRY VIEW'],
        width:{ xs:'12', sm:'4',lg:'4'}
    },
    {
        id:'EntriesWarehouseDonut',
        component:'EntriesWarehouseDonut',
        title: 'widget_entries_by_warehouse_capacity',
        img: require('@/assets/images/demo/EntryDonutWarehouse.png'),
        can:['IU ENTRY VIEW'],
        width:{ xs:'12', sm:'4',lg:'4'}
    },
    {
        id:'LoadOrderStatusCards',
        component:'LoadOrdersCards',
        title: 'widget_load_order_by_status',
        img: require('@/assets/images/demo/LoadOrderCardsStatus.png'),
        can:['IU LOAD ORDER VIEW'],
        width:{ xs:'12', sm:'4',lg:'4'},
    },
    {
        id:'DiscrepanciesClientBar',
        component:'DiscrepanciesBarPlotByClient',
        title: 'widget_discrepancies_by_client',
        img: require('@/assets/images/demo/DiscrepancyBarClient.png'),
        can:['IU DISCREPANCY VIEW'],
        width:{ xs:'12', sm:'4',lg:'4'}
    },
    {
        id:'DiscrepanciesSupplierDonut',
        component:'DiscrepanciesDonutBySupplier',
        title: 'widget_discrepancies_by_supplier',
        img: require('@/assets/images/demo/DiscrepancyDonutSupplier.png'),
        can:['IU DISCREPANCY VIEW'],
        width:{ xs:'12', sm:'4',lg:'4'}
    },
    {
        id:'DiscrepanciesTypeTreemap',
        component:'DiscrepanciesTreemapByType',
        title: 'widget_discrepancies_by_type',
        img: require('@/assets/images/demo/DiscrepancyTreemapType.png'),
        can:['IU DISCREPANCY VIEW'],
        width:{ xs:'12', sm:'4',lg:'4'}
    },
    {
        id:'ReviewOrderBarClient',
        component:'ReviewOrdersBarPlotByClient',
        title: 'widget_review_oder_by_client',
        img: require('@/assets/images/demo/ReviewOrderBarStatus.png'),
        can:['IU REVIEW ORDER VIEW'],
        width:{ xs:'12', sm:'8',lg:'8'}
    },
    {
        id:'ReviewOrdersCardsStatus',
        component:'ReviewOrdersCards',
        title: 'widget_review_oder_by_status',
        img: require('@/assets/images/demo/ReviewOrderCardStatus.png'),
        can:['IU REVIEW ORDER VIEW'],
        width:{ xs:'12', sm:'4',lg:'4'}
    },
    {
        id:'ReviewOrdersDonutStatus',
        component:'ReviewOrdersDonutByStatus',
        title: 'widget_review_oder_by_status',
        img: require('@/assets/images/demo/ReviewOrderDonutStatus.png'),
        can:['IU REVIEW ORDER VIEW'],
        width:{ xs:'12', sm:'4',lg:'4'}
    },
]

export default charts